var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-subscribers-page omapi-subscribers-overview omapi-card__flex"},[_c('monsterleads-overview-stats-widget',[_c('monsterleads-overview-graph')],1),_c('monsterleads-overview-campaigns-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }